import type { MenuPreview } from '@agos/shared'

/**
 * The sidebar catalogue the shell lends the roles editor - `FRONTEND.md` §9.752's *Na obrazovke*.
 *
 * **Read off the sidebar's own entries**, the generated nav tree and AGOS's additions, by the guard each one is drawn
 * under: an entry gated on a right is the screen that right opens, and an entry gated on either of several (a hub,
 * §9.302) is a screen each of them opens. So the editor names exactly the entries the sidebar would draw, by the
 * labels it draws them with - and a right no entry is gated on (`fiskal_storno`, a button inside a screen) names none,
 * rather than a guess.
 */
export interface CatalogueSection {
  items: readonly {
    label: string
    guard?: { permission?: string; anyPermission?: readonly string[] } | undefined
  }[]
}

export function menuPreviewOf(sections: readonly CatalogueSection[]): MenuPreview {
  const screens = new Map<string, string[]>()
  for (const section of sections) {
    for (const item of section.items) {
      const keys = [item.guard?.permission, ...(item.guard?.anyPermission ?? [])].filter(
        (key): key is string => typeof key === 'string' && key !== '',
      )
      for (const key of new Set(keys)) {
        const named = screens.get(key) ?? []
        if (!named.includes(item.label)) named.push(item.label)
        screens.set(key, named)
      }
    }
  }
  return { screensOf: (permission) => screens.get(permission) ?? [] }
}
